module.exports = __webpack_public_path__ + "static/ChildParent-b8f83a1c1fbfb1d60d1b1ad351773351.png";